export default "__VITE_ASSET__BQCEtDol__"